/* FACEPLANT reviews: horizontal snap-scroll row with a photo lightbox.
   Drops into any page that has <div id="fp-reviews"></div>.
   Sample content for the build. Swap REVIEWS for the review app before launch. */
(function () {
  if (window.__fpReviews) return;
  window.__fpReviews = true;

  var A = '#4FC23A', DEEP = '#3A9429', INK = '#121410', MUTED = '#5A5E54',
      BORDER = '#E3E2DC', STAR = '#F2C230';
  var BASE = (window.FP_ASSETS || '/cdn/shop/t/2/assets/');

  var REVIEWS = [
    { img: 'ugc-01-kitchen-basil.webp', name: 'Dee W.', date: '8 September', stars: 5,
      body: 'I check this thing more than my phone and I am not even embarrassed. Seeing the water in millilitres is so satisfying. No more standing in the kitchen going, did I water you on Tuesday?' },
    { img: 'ugc-02-desk-pothos.webp', name: 'Marley T.', date: '12 September', stars: 5,
      body: 'Okay I am obsessed. I have killed a pothos, a fern and something the shop swore was unkillable, and this one is thriving at four months. It kept pulling a sad face every evening and that is how I found out my radiator was cooking it.' },
    { img: 'ugc-03-shelf-fittonia.webp', name: 'Nicole B.', date: '19 August', stars: 5,
      body: 'Turns out I have been drowning my plants for about six years. The soil moisture number sorted that out in a week. Everything on my shelf looks happier, me included.' },
    { img: 'ugc-04-counter-rosemary.webp', name: 'J. Okafor', date: '29 August', stars: 5,
      body: 'Setup took about a minute. Water in the pot, plant on the sleeve, done. My partner said it was a bit much. My partner now says good morning to it.' },
    { img: 'ugc-05-bedside-snake.webp', name: 'Sam H.', date: '24 August', stars: 5,
      body: 'Third one! Kitchen, desk, and one went to my mum who has never kept a plant past August. Hers is still going strong and she will not stop sending me photos of it.' },
    { img: 'ugc-06-windowsill-aglaonema.webp', name: 'Priya R.', date: '3 September', stars: 5,
      body: 'Bought it because it is adorable, kept it because it actually taught me something. My calathea kept crisping and it turns out my flat sits at 38 percent humidity in winter. Mystery solved!' },
    { img: 'ugc-07-bath-snake-purple.webp', name: 'Ines M.', date: '16 September', stars: 5,
      body: 'Put it in the bathroom on a whim and the snake plant has never been happier. The purple is gorgeous in person, much softer than on screen.' },
    { img: 'ugc-08-floor-monstera-thirsty.webp', name: 'Callum D.', date: '14 September', stars: 5,
      body: 'It gave me the sad face and I genuinely felt bad, so I watered it. Works better than any reminder app I have ever ignored.' },
    { img: 'ugc-09-shelf-spider-yellow.webp', name: 'Bea N.', date: '11 September', stars: 5,
      body: 'My spider plant has thrown out two babies since it moved in. The little sparkles on the screen when the light is good make me unreasonably happy.' },
    { img: 'ugc-10-dresser-peacelily-pink.webp', name: 'Yusuf A.', date: '9 September', stars: 5,
      body: 'The peace lily flowered for the first time ever. I am taking full credit even though the pot did all the work.' },
    { img: 'ugc-11-hallway-zz-lowlight.webp', name: 'Tess R.', date: '7 September', stars: 4,
      body: 'Told me my hallway was too dark, which, fair. Moved it nearer the window and it cheered right up. Only wish the screen was a touch brighter in daylight.' },
    { img: 'ugc-12-bookshelf-pothos-purple.webp', name: 'Ravi S.', date: '5 September', stars: 5,
      body: 'Sat it on top of the bookshelf and the pothos has gone absolutely wild. Best looking thing in the room now.' },
    { img: 'ugc-13-window-basil-hot.webp', name: 'Lena K.', date: '2 September', stars: 5,
      body: 'It showed the hot face on a heatwave afternoon and I moved the basil off the sill. Basil survived the week. Genuinely useful.' },
    { img: 'ugc-14-desk-fittonia-night.webp', name: 'Owen B.', date: '31 August', stars: 5,
      body: 'Late night study buddy. The glow is soft enough that it is not distracting and it makes the desk feel less grim at 1am.' },
    { img: 'ugc-15-shelf-aloe-green.webp', name: 'Marta P.', date: '28 August', stars: 5,
      body: 'Simple, tidy, does exactly what it says. The aloe is thriving and I have stopped second guessing myself.' },
    { img: 'ugc-16-sidetable-palm-purple.webp', name: 'Dan W.', date: '26 August', stars: 5,
      body: 'The palm looks incredible in this. Guests always ask about it and then spend five minutes making faces at it.' },
    { img: 'ugc-17-sill-seedling-yellow.webp', name: 'Aoife G.', date: '22 August', stars: 5,
      body: 'Started a tiny seedling in it and watching it come up next to the little face has been the highlight of my month.' },
    { img: 'ugc-18-winter-calathea-cold.webp', name: 'Henrik L.', date: '20 August', stars: 5,
      body: 'Showed me a cold face in January and I realised the windowsill was freezing overnight. Moved it two feet and the calathea stopped sulking.' },
    { img: 'ugc-19-hallway-rubber-green.webp', name: 'Simone T.', date: '17 August', stars: 5,
      body: 'Sits by the front door and it is the first thing I see coming home. Rubber plant is putting out new leaves constantly.' },
    { img: 'ugc-20-office-aglaonema-thirsty.webp', name: 'Peter V.', date: '13 August', stars: 4,
      body: 'Great on a work desk. Caught the thirsty face between meetings and sorted it in ten seconds. Would love a dark mode for the screen at night.' },
    { img: 'ugc-21-shelf-philodendron-purple.webp', name: 'Grace O.', date: '10 August', stars: 5,
      body: 'The philodendron has doubled since I moved it in here. I did nothing different except stop guessing.' },
    { img: 'ugc-22-overhead-pothos-excellent.webp', name: 'Nadia F.', date: '7 August', stars: 5,
      body: 'Excellent light apparently! Very smug about my window placement now. Looks brilliant from above too, which I did not expect to care about.' },
    { img: 'ugc-23-lowangle-snake-good.webp', name: 'Ben C.', date: '4 August', stars: 5,
      body: 'Bigger and sturdier than I expected. The yellow is a proper buttery colour, not neon. Snake plant is loving it.' },
    { img: 'ugc-24-macro-screen-dehydration.webp', name: 'Julia E.', date: '1 August', stars: 5,
      body: 'The faces are so much crisper in person. You can see every pixel. The dehydration one is genuinely a bit heartbreaking, which is clearly the point.' },
    { img: 'ugc-27-held-fittonia-abundant.webp', name: 'Rob H.', date: '23 July', stars: 5,
      body: 'Lighter than it looks and really nicely made. Gave it a full tank and it pulled the happiest little face at me.' },
    { img: 'ugc-30-tablelevel-peacelily-happy.webp', name: 'Clara J.', date: '14 July', stars: 5,
      body: 'Glows beautifully in the evening. My peace lily has never looked this upright and I am taking that as a win.' },
  ];

  var css = document.createElement('style');
  css.textContent = [
    '.fpr-hd{display:flex;align-items:baseline;justify-content:space-between;gap:12px 24px;flex-wrap:wrap;margin-bottom:18px}',
    '.fpr-hd h2{font-family:Outfit,sans-serif;font-weight:700;font-size:clamp(24px,2.6vw,32px);letter-spacing:-.02em;margin:0;color:' + INK + '}',
    '.fpr-avg{display:flex;align-items:center;gap:10px;font-size:14px;color:' + MUTED + '}',
    '.fpr-avg b{color:' + INK + ';font-size:16px}',
    '.fpr-stars{color:' + STAR + ';letter-spacing:1px}',
    '#fp-reviews{width:100%;min-width:0;max-width:min(1200px, calc(100vw - 40px));margin:0 auto}',
    '.fpr-wrap{position:relative;min-width:0;max-width:100%;overflow:hidden}',
    '.fpr-row{display:flex;gap:16px;width:100%;min-width:0;max-width:100%;overflow-x:auto;scroll-snap-type:x mandatory;scroll-behavior:smooth;padding:4px 0 18px;-webkit-overflow-scrolling:touch;scrollbar-width:thin}',
    '.fpr-row::-webkit-scrollbar{height:6px}',
    '.fpr-row::-webkit-scrollbar-thumb{background:' + BORDER + ';border-radius:999px}',
    '.fpr-card{scroll-snap-align:start;flex:0 0 min(340px,82vw);background:#fff;border:1px solid ' + BORDER + ';border-radius:18px;padding:16px;display:flex;flex-direction:column;gap:10px}',
    '.fpr-card figure{margin:0;cursor:zoom-in;border-radius:14px;overflow:hidden;background:' + BORDER + ';aspect-ratio:4/5}',
    '.fpr-card figure img{width:100%;height:100%;object-fit:cover;display:block;transition:transform 200ms ease-out}',
    '.fpr-card figure:hover img{transform:scale(1.03)}',
    '.fpr-meta{display:flex;align-items:center;gap:8px;flex-wrap:wrap;font-size:13px}',
    '.fpr-meta .n{font-weight:700;color:' + INK + '}',
    '.fpr-vb{padding:2px 8px;border-radius:999px;background:#EAF7E6;color:' + DEEP + ';font-weight:600;font-size:12px}',
    '.fpr-d{color:' + MUTED + '}',
    '.fpr-body{font-size:14.5px;line-height:1.5;color:#3E4239;margin:0}',
    '.fpr-nav{position:absolute;top:calc(50% - 28px);width:44px;height:44px;border-radius:999px;border:1px solid ' + BORDER + ';background:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:19px;color:' + INK + ';z-index:2}',
    '.fpr-nav[hidden]{display:none}',
    '.fpr-prev{left:-14px}.fpr-next{right:-14px}',
    '@media (max-width:760px){.fpr-nav{display:none}}',
    '.fpr-lb{position:fixed;inset:0;background:rgba(14,16,14,.88);display:none;align-items:center;justify-content:center;z-index:10000;padding:24px}',
    '.fpr-lb.on{display:flex}',
    '.fpr-lb img{max-width:min(92vw,720px);max-height:82vh;border-radius:18px;display:block}',
    '.fpr-lb figcaption{color:#EDEFEA;font-size:14px;text-align:center;margin-top:14px;max-width:min(92vw,720px)}',
    '.fpr-lbx{position:absolute;top:18px;right:22px;background:none;border:0;color:#fff;font-size:34px;line-height:1;cursor:pointer}',
    '.fpr-lbn{position:absolute;top:50%;transform:translateY(-50%);background:rgba(255,255,255,.14);border:0;color:#fff;width:48px;height:48px;border-radius:999px;font-size:22px;cursor:pointer}',
    '.fpr-lbp{left:18px}.fpr-lbnx{right:18px}',
    '.fpr-hov{position:fixed;z-index:9990;pointer-events:none;opacity:0;transform:scale(.96);transition:opacity 140ms ease-out,transform 140ms ease-out;border-radius:18px;overflow:hidden;box-shadow:0 18px 50px rgba(14,16,14,.28)}',
    '.fpr-hov.on{opacity:1;transform:scale(1)}',
    '.fpr-hov img{display:block;width:100%;height:100%;object-fit:cover}',
    '@media (hover:none){.fpr-hov{display:none}}',
    '@media (prefers-reduced-motion:reduce){.fpr-row{scroll-behavior:auto}.fpr-card figure img{transition:none}.fpr-hov{transition:none}}'
  ].join('');
  document.head.appendChild(css);

  function stars(n) { return '★'.repeat(n) + '☆'.repeat(5 - n); }

  function build(host) {
    var avg = (REVIEWS.reduce(function (a, r) { return a + r.stars; }, 0) / REVIEWS.length).toFixed(1);
    host.innerHTML =
      '<div class="fpr-hd"><h2>What people say</h2>' +
      '<div class="fpr-avg"><span class="fpr-stars">' + stars(5) + '</span><b>' + avg + '</b> out of 5 from ' + REVIEWS.length + ' reviews</div></div>' +
      '<div class="fpr-wrap">' +
        '<button class="fpr-nav fpr-prev" aria-label="Previous reviews">&#8249;</button>' +
        '<div class="fpr-row">' +
          REVIEWS.map(function (r, i) {
            return '<article class="fpr-card">' +
              '<figure data-i="' + i + '"><img src="' + BASE + r.img + '" alt="Photo from ' + r.name + '" loading="lazy"></figure>' +
              '<div class="fpr-meta"><span class="fpr-stars">' + stars(r.stars) + '</span>' +
              '<span class="n">' + r.name + '</span><span class="fpr-vb">Verified buyer</span>' +
              '<span class="fpr-d">' + r.date + '</span></div>' +
              '<p class="fpr-body">' + r.body + '</p></article>';
          }).join('') +
        '</div>' +
        '<button class="fpr-nav fpr-next" aria-label="More reviews">&#8250;</button>' +
      '</div>';

    var row = host.querySelector('.fpr-row');
    var prev = host.querySelector('.fpr-prev'), next = host.querySelector('.fpr-next');
    function step(dir) { row.scrollBy({ left: dir * (row.clientWidth * 0.8), behavior: 'smooth' }); }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    function arrows() {
      prev.hidden = row.scrollLeft < 8;
      next.hidden = row.scrollLeft + row.clientWidth >= row.scrollWidth - 8;
    }
    row.addEventListener('scroll', arrows); window.addEventListener('resize', arrows); arrows();

    host.addEventListener('click', function (e) {
      var fig = e.target.closest('figure[data-i]');
      if (fig) openLb(parseInt(fig.getAttribute('data-i'), 10));
    });
  }

  // lightbox, shared
  var lb = document.createElement('div');
  lb.className = 'fpr-lb';
  lb.innerHTML = '<button class="fpr-lbx" aria-label="Close">&times;</button>' +
    '<button class="fpr-lbn fpr-lbp" aria-label="Previous">&#8249;</button>' +
    '<figure style="margin:0"><img alt=""><figcaption></figcaption></figure>' +
    '<button class="fpr-lbn fpr-lbnx" aria-label="Next">&#8250;</button>';
  function mountLb() { if (!lb.parentNode && document.body) document.body.appendChild(lb); }
  var cur = 0;
  function openLb(i) {
    mountLb(); cur = i; paint(); lb.classList.add('on'); document.body.style.overflow = 'hidden';
  }
  function paint() {
    var r = REVIEWS[cur];
    lb.querySelector('img').src = BASE + r.img;
    lb.querySelector('figcaption').textContent = r.name + ' · ' + r.date;
  }
  function closeLb() { lb.classList.remove('on'); document.body.style.overflow = ''; }
  lb.addEventListener('click', function (e) {
    if (e.target === lb || e.target.closest('.fpr-lbx')) return closeLb();
    if (e.target.closest('.fpr-lbp')) { cur = (cur - 1 + REVIEWS.length) % REVIEWS.length; paint(); }
    if (e.target.closest('.fpr-lbnx')) { cur = (cur + 1) % REVIEWS.length; paint(); }
  });
  document.addEventListener('keydown', function (e) {
    if (!lb.classList.contains('on')) return;
    if (e.key === 'Escape') closeLb();
    if (e.key === 'ArrowLeft') { cur = (cur - 1 + REVIEWS.length) % REVIEWS.length; paint(); }
    if (e.key === 'ArrowRight') { cur = (cur + 1) % REVIEWS.length; paint(); }
  });

  // hover preview, desktop only
  var hov=document.createElement('div');
  hov.className='fpr-hov';
  hov.innerHTML='<img alt="">';
  function mountHov(){ if(!hov.parentNode && document.body) document.body.appendChild(hov); }
  function showHov(fig, src){
    if(!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    mountHov();
    var W=380, H=Math.round(W*1.25);
    var r=fig.getBoundingClientRect();
    var left=Math.min(Math.max(12, r.left + r.width/2 - W/2), window.innerWidth - W - 12);
    var top=Math.min(Math.max(12, r.top + r.height/2 - H/2), window.innerHeight - H - 12);
    hov.style.width=W+'px'; hov.style.height=H+'px';
    hov.style.left=left+'px'; hov.style.top=top+'px';
    hov.querySelector('img').src=src;
    hov.classList.add('on');
  }
  function hideHov(){ hov.classList.remove('on'); }
  document.addEventListener('mouseover', function(e){
    var fig=e.target.closest && e.target.closest('.fpr-card figure[data-i]');
    if(fig) showHov(fig, fig.querySelector('img').src);
  });
  document.addEventListener('mouseout', function(e){
    var fig=e.target.closest && e.target.closest('.fpr-card figure[data-i]');
    if(fig) hideHov();
  });
  document.addEventListener('scroll', hideHov, true);

  function init() {
    mountLb();
    document.querySelectorAll('#fp-reviews').forEach(build);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // the page runtime renders after load, so retry once
  setTimeout(init, 1200);
})();
